import React, { useEffect, useMemo, useState } from "react";
import { Badge, Drawer, Typography } from "@mui/material";
import InviteGroupMember from "./InviteGroupMember";
import InvitePopup from "../../../common/InvitePopup";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import { Box, Stack } from "@mui/system";
import { createStyledIndicatorButton } from "../../../common/StyledComponents/SideBarComponents";
import { useDispatch, useSelector } from "react-redux";
import group_icon from "../../../assets/images/chats/group_icon.svg";
import buyer_seller_grp_icon from "../../../assets/images/chats/buyer_seller_grp_icon.svg";
import {
  crossIcon,
  crossIconDiv,
  personIconStyle,
} from "../../../assets/commonFunction";
import PersonIcon from "../../../assets/images/chats/person.svg";
import { useTranslation } from "react-i18next";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import { Check } from "@mui/icons-material";
import Tick from "../../../assets/images/Profile/approve_tick.svg";
import { getAllGroupInvites } from "../../../appStore/actions/ArkchatGroup/action";
import { allWorkspacesSelector, groupsInView } from "../../../utils/workspaceView";

const classes = {
  drawerBody: {
    minWidth: "21.25rem",
    maxWidth: "31.25rem",
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,

  internalExternalButton: {
    background: "white",
    border: "1px solid #183243",
    color: "#183243",
    borderRadius: "0px",
    fontSize: "0.75rem",
    textTransform: "none",
    "&:hover": {
      background: "white",
    },
  },

  activeButton: {
    "&:hover": {
      background: "#183243",
    },
    background: "#183243",
    borderRadius: "0px",
    color: "white",
    fontSize: "0.75rem",
    textTransform: "none",
    border: "1px solid #183243",
  },

  iconn: crossIcon,
  radiogp: {
    display: "block",
  },
  groupMember: {
    backgroundColor: "#F3F3F3",
    padding: "20px 10px",
  },

  // add group member
  addgmember: {
    transform: "translate(0, 70%)",
    textAlign: "center",
  },
  // add group member
  headingText: {
    color: "black",
    fontSize: "14px",
    fontWeight: "400",
    "@media (max-width: 63em)": {
      fontSize: "0.8rem",
    },
  },

  selectedItem: {
    // backgroundColor: "#183243",
    backgroundColor: "#E1E1E1",
    color: "#000",
  },
  nonselectedItem: {
    color: "#000",
  },
};

const InviteMemberDrawer = ({
  isaddmemberOpen,
  closePopUp,
  handleGroupProfileBadgeClick,
  //   classes,
}) => {
  const { selectedGroup, groupList: chats, archiveGroupList: archivedChats } = useAppSelectors();
  const allWorkspaces = useSelector(allWorkspacesSelector);
  const [selectedGroupData, setSelectedGroupData] = useState(null);
  const SmallActionButton = createStyledIndicatorButton("#E3E1E1");
  const groupList = useSelector(
    (state) => state?.arkchatgroup?.allGroupInvite?.data
  );
  const userData = useSelector((state) => state?.profile);
  const activeWorkspaceId = userData?.profileData?.data?.activeSubscriber?.id;
  const groupsShown = useMemo(
    () => groupsInView(groupList, [...(chats || []), ...(archivedChats || [])], allWorkspaces, activeWorkspaceId),
    [groupList, chats, archivedChats, allWorkspaces, activeWorkspaceId]
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const appContent = t("AppContent", { returnObjects: true });

  useEffect(() => {
    if (isaddmemberOpen) {
      dispatch(getAllGroupInvites());
    }
  }, [isaddmemberOpen, dispatch]);

  const handleOpenMenu = (item) => setSelectedGroupData(item);
  const handleCloseMenu = () => setSelectedGroupData(null);

  return (
    <>
      {/* Popup inside Drawer */}
      {selectedGroupData && (
        <InvitePopup
          closePopUp={handleCloseMenu}
          isGroupInvite={true}
          groupData={selectedGroupData}
        />
      )}

      <Drawer
        sx={{ zIndex: 1202, minWidth: "19.25rem" }}
        open={isaddmemberOpen}
        onClose={closePopUp}
        anchor="right"
      >
        <Box sx={classes.drawerBody}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={classes.header}
          >
            <Stack direction="row" alignItems="center" spacing={3.6}>
              <Typography sx={classes.iconDiv}>
                <CloseIcon
                  sx={classes.iconn}
                  onClick={closePopUp} // close drawer on click
                />
              </Typography>
              <Typography color={"black"}>Invite</Typography>
            </Stack>
          </Stack>

          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mt={"0.4rem"}
            ml={"0.5rem"}
            rowGap={"0.4rem"}
            sx={{
              "&::-webkit-scrollbar": {
                width: "0px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#F9F8F8",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "grey",
              },
            }}
          >
            {groupsShown?.map((item, i) => {
                return (
                  <Box
                    key={item?.id + "groupList" + i + "unique"}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      gap: "0.4rem",
                      paddingRight: "0.6rem",
                    }}
                  >
                    {/* Left: Avatar / Icon */}
                    <SmallActionButton
                      size="small"
                      variant="contained"
                      sx={{
                        padding:
                          item?.accountDetails?.profileImgUrl && !item?.isGroup
                            ? "0px"
                            : "6px",
                        overflow: "hidden",
                        flexShrink: 0,
                      }}
                      onClick={() =>
                        item?.isGroup
                          ? handleGroupProfileBadgeClick(
                              item,
                              item?.isGroup,
                              item?.isBuyerSellerGroup
                            )
                          : handleGroupProfileBadgeClick(item, item?.isGroup)
                      }
                    >
                      <img
                        style={{ width: "100%", height: "100%" }}
                        src={
                          item?.isGroup
                            ? item?.isBuyerSellerGroup
                              ? buyer_seller_grp_icon
                              : group_icon
                            : item?.accountDetails?.profileImgUrl || group_icon
                        }
                        alt="profile"
                      />
                    </SmallActionButton>

                    {/* Middle: Name */}
                    <Typography
                      variant="body2"
                      sx={{
                        flexGrow: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        color: "black",
                        fontSize: "13px",
                        cursor: "pointer",
                      }}
                      title={item?.name}
                      onClick={() => {
                        handleOpenMenu(item);
                      }}
                    >
                      {item?.name}
                      {!item?.isGroup &&
                        item?.id === userData?.profileData?.data?.id && (
                          <Typography ml={"0.1rem"} variant="caption">
                            ({appContent?.KEY5})
                          </Typography>
                        )}
                    </Typography>

                    {/* Right: Tick mark */}
                    {selectedGroup?.pnId === item?.pnId &&
                      selectedGroup?.name === item?.name && (
                        <img
                          src={Tick}
                          alt="selected"
                          style={{ width: 18, height: 18, flexShrink: 0 }}
                        />
                      )}
                  </Box>
                );
              })}
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default InviteMemberDrawer;
